import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiX } = FiIcons;

export default function ReconciliationSuccessModal({
  accountName,
  onClose,
  onViewHistory
}) {
  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/55 p-4 backdrop-blur-sm">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="reconciliation-success-title"
        className="relative w-full max-w-2xl overflow-hidden rounded-3xl bg-white px-6 py-10 text-center shadow-2xl sm:px-12"
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-5 top-5 rounded-full p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
          aria-label="Close confirmation"
        >
          <SafeIcon icon={FiX} className="text-xl" />
        </button>

        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full border-4 border-emerald-100 bg-emerald-600 text-white shadow-lg shadow-emerald-200">
          <SafeIcon icon={FiCheck} className="text-5xl" />
        </div>

        <h2
          id="reconciliation-success-title"
          className="mx-auto mt-7 max-w-lg text-3xl font-black tracking-tight text-slate-900 sm:text-4xl"
        >
          Your books are now reconciled
        </h2>

        <p className="mx-auto mt-4 max-w-xl text-base font-medium leading-relaxed text-slate-600 sm:text-lg">
          Your {accountName} ledger balance matches the statement closing balance.
          The completed period is now locked for audit integrity.
        </p>

        <button
          type="button"
          onClick={onViewHistory}
          className="mt-8 rounded-xl bg-blue-600 px-7 py-3 text-sm font-black text-white shadow-lg shadow-blue-200 transition-all hover:bg-blue-700 active:scale-[0.98]"
        >
          Go to reconciliation history
        </button>
      </div>
    </div>
  );
}